// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buscador-usuarios{
    position: relative;
    display: flex; 
    border-radius: 8px; 
    overflow: hidden;
    border-bottom: 5px solid #007932;
    width: 425px;
  }
  
.buscador-usuarios svg{
    position: absolute;
    left: 20px;
    color: #007932;
}
  
.buscador-usuarios input{
    width: 100%;
    padding: 8px 10px 8px 45px;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 500;
}

.buscador-usuarios input::placeholder{ color: black; font-weight: 500;}`, "",{"version":3,"sources":["webpack://./src/components/css/Buscador.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;EACd;;AAEF;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA,uCAAuC,YAAY,EAAE,gBAAgB,CAAC","sourcesContent":[".buscador-usuarios{\n    position: relative;\n    display: flex; \n    border-radius: 8px; \n    overflow: hidden;\n    border-bottom: 5px solid #007932;\n    width: 425px;\n  }\n  \n.buscador-usuarios svg{\n    position: absolute;\n    left: 20px;\n    color: #007932;\n}\n  \n.buscador-usuarios input{\n    width: 100%;\n    padding: 8px 10px 8px 45px;\n    border: none;\n    outline: none;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.buscador-usuarios input::placeholder{ color: black; font-weight: 500;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
